import handlebars from "handlebars";
import swotGlobalTemplate from "../templates/swotGlobalTemplate";

export const compileSwotGlobalTemplate = (commentData: any[]): string => {
    const compile = handlebars.compile(swotGlobalTemplate);
    const Comment: any = commentData || [];
    
    const SwotGlobalComment = {
        assetStrengthComment: Comment?.find((x) => x.commentKey?.toLowerCase() === "asset_strength")?.commentText || "",
        assetWeaknessComment: Comment?.find((x) => x.commentKey?.toLowerCase() === "asset_weakness")?.commentText || "",
        assetOpportunitiesComment: Comment?.find((x) => x.commentKey?.toLowerCase() === "asset_opportunities")?.commentText || "",
        assetThreatsComment: Comment?.find((x) => x.commentKey?.toLowerCase() === "asset_threats")?.commentText || "",
        
        sustainabilityStrengthComment: Comment?.find((x) => x.commentKey?.toLowerCase() === "sustainability_strength")?.commentText || "",
        sustainabilityWeaknessComment: Comment?.find((x) => x.commentKey?.toLowerCase() === "sustainability_weakness")?.commentText || "",
        sustainabilityOpportunitiesComment: Comment?.find((x) => x.commentKey?.toLowerCase() === "sustainability_opportunities")?.commentText || "",
        sustainabilityThreatsComment: Comment?.find((x) => x.commentKey?.toLowerCase() === "sustainability_threats")?.commentText || "",
        
        leasingStrengthComment: Comment?.find((x) => x.commentKey?.toLowerCase() === "leasing_strength")?.commentText || "",
        leasingWeaknessComment: Comment?.find((x) => x.commentKey?.toLowerCase() === "leasing_weakness")?.commentText || "",
        leasingOpportunitiesComment: Comment?.find((x) => x.commentKey?.toLowerCase() === "leasing_opportunities")?.commentText || "",
        leasingThreatsComment: Comment?.find((x) => x.commentKey?.toLowerCase() === "leasing_threats")?.commentText || "",
        
        marketStrengthComment: Comment?.find((x) => x.commentKey?.toLowerCase() === "market_strength")?.commentText || "",
        marketWeaknessComment: Comment?.find((x) => x.commentKey?.toLowerCase() === "market_weakness")?.commentText || "",
        marketOpportunitiesComment: Comment?.find((x) => x.commentKey?.toLowerCase() === "market_opportunities")?.commentText || "",
        marketThreatsComment: Comment?.find((x) => x.commentKey?.toLowerCase() === "market_threats")?.commentText || "",
    };
    
    return compile(SwotGlobalComment);
};
